import React from "react";
import { StaticImage } from "gatsby-plugin-image";

import ImgDivider from './icons/Dementia/ImgDivider'

import "../../scss/main.scss";
import ProgressiveSymptoms from "./icons/ProgressiveSymptoms";
import ProgressiveSymptomsMobile from "./icons/ProgressiveSymptomsMobile";
import QuestionMark from "./icons/QuestionMark";
import Accordion from "./Accordion";


export const ConditionSplash = ({children}) => (
	<section>
		<div className="dementia-landing">
			{children}
		</div>
		<hr />
	</section>
)

export const ConditionDescription = ({children}) => (
	<section>
		<div className="dementia-descrip">
			{children}
		</div>
	</section>
)

export const ConditionDescriptionRightPanel = ({children}) => (
	<div className="descrip">
		{children}
	</div>
)

export const ConditionDescriptionRightPanelParagraph = ({children}) => (
	<p className="primary dem">
		{children}
	</p>
)

export const ConditionInfographicSection = ({children}) => (
	<section>
		<div className="dementia-infographic">
			{children}
		</div>
	</section>
)

export const ConditionInfographicSectionIntro = ({children}) => (
	<>
		<div className="dementia-intro">
			<div className="descrip-img">
				<QuestionMark />
			</div>
			{children}
		</div>
		<div className="img-divider">
			<ImgDivider />
		</div>
	</>
)

export const ConditionInfographicMainContent = ({children}) => (
	<div className="dementia-main">
		{children}
	</div>
)

export const ConditionInfographicDescription = ({children}) => (
	<div className="dementia-info">
		<div className="dementia-img-people" >
			<StaticImage height={72} placeholder="blurred" src="../../static/assets/marketing-site/images/dementia-image-a.png" />
			<StaticImage height={72} placeholder="blurred" src="../../static/assets/marketing-site/images/dementia-image-b.png" />
			<StaticImage height={72} placeholder="blurred" src="../../static/assets/marketing-site/images/dementia-image-c.png" />
		</div>
		{children}
	</div>
)

export const ConditionInfographicDescriptionParagraph = ({children}) => (
	<p className="secondary pro">
		{children}
	</p>
)

export const ConditionsInforgraphicTypes = ({children}) => (
	<div className="dementia-section">
		<div className="dementia-dropdown">
			{children}
		</div>
		<StaticImage placeholder="blurred"
			src="../../static/assets/marketing-site/images/dementia-icon-05.svg" className="desktop-only" 
		/>
	</div>
)

export const ConditionsInfographicTypesHeading = ({children}) => (
	<div className="dementia-dropdown-heading">
		<p>{children}</p>
		<hr />
	</div>
)

export const ConditionsInfographicTypesDetail = ({children}) => (
	<div className="dementia-forms">
		{children}
	</div>
)

const AccordionTitle = ({children, isExpanded, transition}) => (
	<h3 style={{
		transition: `opacity ${transition[0]}ms ${transition[1]}`,
		opacity: isExpanded ? '1' : '0.7'
	}}>
		{children}
	</h3>
)


export const ConditionsInfographicTypesDetailSection = ({children, title}) => (
	<Accordion indentation={0} className="dementia-form" renderTitle={(accordianProps)=><AccordionTitle {...accordianProps}>{title}</AccordionTitle>}>
		<div className="dementia-form-stats accordion-items-container dementia">
			{children}
		</div>
	</Accordion>
)

export const ConditionsInfographicSymptons = ({children}) => (
	<div className="dementia-symptons">
		{children}
	</div>
)

export const ConditionsInfographicSymptonsHeader = ({children}) => (
	<div className="symptons-descriptions">	
		<h1>Symptoms</h1>
		<br />
		<p className="secondary pro">
			{children}
		</p>
	</div>
)

export const ConditionsInfographicSymptonsMainCopy = ({children}) => (
	<p className="secondary pro">
		{children}
	</p>
)

export const ConditionsInfographicSymptonDiagram = ({children}) => (
	<div className="symptoms-diagram">
		<ProgressiveSymptoms className="desktop-only"/>
		<ProgressiveSymptomsMobile className="mobile-only"/>
		<div className="diagram">
			{children}
		</div>
	</div>
)

export const ConditionsInfographicSymptonDiagramMainCopy = ({children}) => (
	<>
		<div className="diagram-descrip">
			<p className="secondary pro">
				{children}
			</p>
		</div>
		<hr className="conditions-infographic__green-hr" />
	</>
)

export const ConditionsInfographicSymptonDiagramTopics = ({children}) => (
	<div className="diagram-topics">
		{children}
	</div>
)


export const ConditionsInfographicSymptonDiagramTopic = ({children}) => (
	<div className="diagram-topic-one">
		{children}
	</div>
)


export const ConditionsInfographicSymptonDiagramTopicHeading = ({children}) => (
	<p className="secondary heading">
		{children}
	</p>
)


export const ConditionsInfographicSymptonDiagramTopicCopy = ({children}) => (
	<p className="secondary pro">
		{children}
	</p>
)

export const ConditionStats = ({children}) => (
	<section>
		<div className="dementia-f-c">
			<div className="f-c-content">
				{children}
			</div>
		</div>
	</section>
)


export const ConditionStatsMainContent = ({children}) => (
	<div className="f-c-stats">
		{children}
	</div>
)

export const ConditionStat = ({children}) => (
	<div className="stats">
		<div>
			{children}

		</div>
	</div>
)

export const ConditionStatCopy = ({children}) => (
	<p className="primary">
		{children}
	</p>
)

export const ConditionStatCopyInline = ({children}) => (
	<p className="primary custom">
		{children}
		&nbsp;
	</p>
)

export const ConditionStatCopyEmph = ({children}) => (
	<h3>
		{children}
	</h3>
)


export const ConditionStatCopyEmphInline = ({children}) => (
	<h3 className="custom">
		{children}
	</h3>
)

export const ConditionLivein = ({children}) => (
	<section>
		<div className="dementia-live-in">
			{children}
		</div>
	</section>
)


export const ConditionLiveinHeader = ({children}) => (
	<div className="dli-heading">
		{children}
	</div>
)

export const ConditionLiveinHeaderCopy = ({children}) => (
	<p className="primary">
			{children}
	</p>
)

export const ConditionLiveinHomeCard = ({children, title}) => (
	<div className="dli-block">
		<h3 className="mobile-view">{title}</h3>
		<StaticImage
			placeholder="blurred"
			src="../../static/assets/marketing-site/images/dementia-image-03.png"
			width={624}
			/>
		<div className="block-text">
			<h3 className="desktop-view">{title}</h3>
			{children}
		</div>
	</div>
)

export const ConditionLiveinHomeCardMainCopy = ({children}) => (
	<p className="secondary pro">
		{children}
	</p>
)

export const ConditionLiveinHomeCardMainTip = ({children}) => (
	<div className="tip">
		{children}
	</div>
)
export const ConditionLiveinHomeCardMainTipTitle = ({children}) => (
	<p className="secondary pro">
		{children}
	</p>
)
export const ConditionLiveinHomeCardMainTipCopy = ({children}) => (
	<p className="secondary pro grey">
		{children}
	</p>
)

export const ConditionTrainingCard = ({children, title}) => (
	<div className="dli-block left">
		<h3 className="mobile-view">{title}</h3>
		<StaticImage 
			placeholder="blurred"
			src="../../static/assets/marketing-site/images/dementia-image-04.png"
			width={624}
		/>
		<div className="block-text">
			<h3 className="desktop-view">
				{title}
			</h3>
			{children}
		</div>
	</div>
)

export const ConditionTrainingCardMainCopy = ({children}) => (
	<p className="secondary pro">
		{children}
	</p>
)

export const ConditionTrainingCardTip = ({children}) => (
	<div className="tip">
		{children}
	</div>
)

export const ConditionTrainingCardTipItem = ({children}) => (
	<li>
		<div className="circle-dementia-activities"></div>
		<span>{children} </span>
	</li>
)